import { Component, OnInit } from '@angular/core';
import { VolunteerCalendar } from '../models/volunteer-calendar.model';
import { LocalstorageService } from '../services/localstorage.service';
import { VolunteerService } from '../services/volunteer.service';
import * as moment from "moment";
import { Router } from '@angular/router';

@Component({
  selector: 'app-volunteer-calendar',
  templateUrl: './volunteer-calendar.component.html',
  styleUrls: ['./volunteer-calendar.component.css']
})
export class VolunteerCalendarComponent implements OnInit {
  volunteerCalendarVm: VolunteerCalendar[];
  upcomingEvents: VolunteerCalendar[];
  pastEvents: VolunteerCalendar[];
  constructor(private volunteerService: VolunteerService, 
    private localstorageService: LocalstorageService,
    private router: Router) { }

  async ngOnInit() {
    this.volunteerCalendarVm = [];
    let authDetails = this.localstorageService.getAuth();
    this.volunteerCalendarVm = await this.volunteerService.getVolunteerEventDetails(authDetails.employeeInfo.corpId).toPromise();
    this.volunteerCalendarVm = this.volunteerCalendarVm.map(e=> { 
      //let tempDate = new Date(e.activityDate);
      return {...e, activityDate: new Date(e.activityDate), start: new Date(e.start)};
    })
    console.log(this.volunteerCalendarVm);
    this.pastEvents = this.volunteerCalendarVm.filter(e=>e.start < new Date()).reverse();
    this.upcomingEvents = this.volunteerCalendarVm.filter(e=> e.start > new Date());
  }

  formatDate(date: Date){
    return moment(date).format('MMMM Do YYYY, h:mm a');
  }

  backToEvent(volunteerEventId: string){
    this.router.navigate(['volunteer-activities', volunteerEventId]);
  }
}
